import React from 'react';

import './styles.scss';

interface IProps {
    url: string;
}

const ShowFile = ({ url }: IProps) => {

    const formatedUrl = url?.split('.')[url?.split('.').length - 1].toLocaleLowerCase();
    const isImage = ['png', 'jpg', 'jpeg', 'tiff'].some(x => formatedUrl.indexOf(x) !== -1);
    const isPdf = ['pdf'].some(x => formatedUrl.indexOf(x) !== -1);

    return (
        <>
            {
                isImage && <img className="rounded ms-2" alt="Skote" width="100%" src={url} />
            }
            {/* {
                isPdf &&
                <object data={url} type="application/pdf" width="100%" height="400px">
                </object>
            } */}
        </>
    );
};

export default ShowFile;